import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconDropRight(props: IconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        d="M15.6758 12.7864C16.1081 12.373 16.1081 11.627 15.6758 11.2136L11.5324 7.25134C10.9303 6.67549 10 7.15285 10 8.03769V15.9623C10 16.8472 10.9303 17.3245 11.5324 16.7487L15.6758 12.7864Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
